import React from 'react';
import styles from './Step.module.css';
import {Icon, IconBadge, Text, useDevice} from '../../Atoms';
import {ColorPair} from '../../Internal';
import {MediaObject} from '../MediaObject';
import {Stack} from '../../Layout';

export type ReferralStepProps = {
  icon: Icon;
  colorPair: ColorPair;
  header: string;
  body: string;
};

export const ReferralStep = ({
  icon,
  colorPair,
  header,
  body,
}: ReferralStepProps) => {
  const {isMobile} = useDevice();

  return (
    <div className={styles.root}>
      <MediaObject
        space={isMobile ? 'md' : 'lg'}
        align={isMobile ? 'start' : 'center'}
      >
        <IconBadge icon={icon} size="lg" colorPair={colorPair} />
        <Stack space={isMobile ? 'sm' : 'md'} className={styles.text}>
          <Text as="p" type={isMobile ? 'bodyHeavy' : 'lgHeader'}>
            {header}
          </Text>
          <Text as="p" type={isMobile ? 'body' : 'caption'}>
            {body}
          </Text>
        </Stack>
      </MediaObject>
    </div>
  );
};
